import React, { useContext, useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'

import { PAGE_TITLE } from '../../Configuration'
import Tabs from '../../components/tabs/tabs'
import usePageTitle from '../../hooks/use-page-title'
import { PreviousPageContext } from '../../store/previous-page-provider'
import { RoleContext } from '../../store/role-context-provider'
import PiiAuditLog from './audit-log/pii-audit-log'
import PiiConfiguration from './configuration/pii-configuration'
import './pii.css'

const PII = () => {
  usePageTitle(PAGE_TITLE.PII)
  const navigate = useNavigate()
  const { isHigherMPF, isLoading } = useContext(RoleContext)
  const { currentPage, setCurrentPage, setPreviousPage } =  useContext(PreviousPageContext)
  const [selectedTabIndex, setSelectedTabIndex] = useState(0)

  const handleTabSelect = (index) => {
    setSelectedTabIndex(index)
  }

  const tableItems = [
    {
      content: <PiiConfiguration />,
      icon: 'icon-pii-configuration',
      isActive: selectedTabIndex === 0,
      tabTitle: 'Configuration',
    },
    {
      content: <PiiAuditLog />,
      icon: 'icon-pii-auditlog',
      isActive: selectedTabIndex === 1,
      tabTitle: 'Audit Log',
    },
  ]
  if (!isLoading) {
    if (!isHigherMPF) {
      navigate('/accessdenied')
    }
  }

  useEffect(() => {
    // This effect runs whenever the location changes (when the user navigates to a different route)
    if (currentPage !== location.pathname) {
      // User has navigated to a new page, so update the previous page
      setPreviousPage(currentPage) // Store the previous page
      setCurrentPage(location.pathname) // Update the current page
    }
  }, [location, currentPage]) // Runs whenever location or currentPage changes
  return (
    <Tabs
      anchorclass='px-2 darktext'
      className='poppins-medium xs tabs-group'
      items={tableItems}
      onTabSelected={handleTabSelect}
      pagetitle='PII'
      pagetitleClass='poppins-semibold font-16 title-color40  align-items-center m-0 p-0'
      pagetitleIcon='icon-pii font-14 me-1 color-primary'
      tablistclassName='font-13 overflow-auto ms-auto bordered2 border-radius piitabs'
      tabsul='py-2 px-3 whitebg shadow1 align-items-center'
    />
  )
}
export default PII
